import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/56/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os dados por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorMicroarea(cod_ibge, nu_ine, microarea) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/56/equipe/${nu_ine}/micro-area/${microarea}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinasAplicadas = JSON.parse(item.vacinas_aplicadas)

    const cores = [
      {
        dose: 'ÚNICA',
        cor: 'white',
        dt_aplicacao_br: '',
      },
    ]
    const unica = encontrarDose(vacinasPendentes, vacinasAplicadas, '56', '9')

    if (unica.tipo == 'aplicada') {
      cores[0].cor = 'green'
      cores[0].dt_aplicacao_br = unica.dt_aplicacao_br
      cores[0].dose_anterior = unica.dose_anterior
    } else {
      cores[0].cor = unica.cor
      cores[0].dt_aplicacao_br = '15 meses'
      cores[0].sg_d = unica.sg_d
      cores[0].sg_im = unica.sg_im
    }

    return {
      index: index,
      ...item,
      cores,
    }
  })
  return data
}

function encontrarDose(vacinasPendentes, vacinasAplicadas, id_im, id_d) {
  if (vacinasPendentes != null) {
    const dosePendente = vacinasPendentes.find(
      (el) => el.id_im == Number(id_im) && el.id_d == Number(id_d)
    )
    if (dosePendente !== undefined) {
      return {
        tipo: 'pendente',
        cor: 'red',
        dt_aplicacao_br: '',
        sg_d: dosePendente.sg_d,
        sg_im: dosePendente.sg_im,
      }
    }
  }
  if (vacinasAplicadas != null) {
    const doseAplicada = vacinasAplicadas.find(
      (el) => el.id_imuno == id_im && el.id_dose_imuno == id_d
    )
    if (doseAplicada !== undefined) {
      return {
        tipo: 'aplicada',
        dt_aplicacao: doseAplicada.dt_aplicacao,
        dt_aplicacao_br: doseAplicada.dt_aplicacao_br,
        dose_anterior: doseAplicada.dose_anterior,
        id_dose_imuno: doseAplicada.id_dose_imuno,
      }
    }
  }
  return {
    tipo: 'pendente',
    cor: 'white',
    dt_aplicacao_br: '',
    sg_d: '',
    sg_im: '',
  }
}

export function exibirVermelhos(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (item.cores.find((element) => element.cor === 'red')) {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (
      item.cores.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      )
    ) {
      return true
    }
  })
  return filtro
}

export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'Tetra viral'
  let titlePdfSave = utils.methods.titlePdf(
    'Tetra viral',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Situação vacinal de crianças com Tetra viral'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'TETRA VIRAL',
    'DOCUMENTO',
  ]
  var data_pdf = []
  let doses = formatarCadastrosComDoses(cadastros)
  for (let i = 0; i < doses.length; i++) {
    let obj = {}
    obj.no_cidadao = doses[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(doses[i].dt_nascimento)
    obj.no_mae = doses[i].no_mae
    obj.ma = doses[i].micro_area
    obj.tetra_viral = ''
    doses[i].cores.forEach((item) => {
      obj.tetra_viral += `${item.dose} - ${item.dt_aplicacao_br} \n`
    })
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)
  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
